import React from 'react';
import PropTypes from 'prop-types';
import { Page, Document, Image, Text, StyleSheet } from '@react-pdf/renderer';

import ReportTableItems from './ReportTableItems';

import ReportTitle from './ReportTitle';
import ReportTableHeader from './ReportTableHeader';

const styles = StyleSheet.create({
  frontpage: {
    flexDirection: 'column',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
  },
  page: {
    fontFamily: 'Times-Roman',
    fontSize: 8,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    paddingBottom: 30,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
  image: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
    maxHeight: '100vh',
  },
  pageNumber: {
    marginTop: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: 50,
  },
});

const Report = ({ title, columns, image, table }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      <ReportTitle title={title} />
      <Image style={styles.image} src={image} />
    </Page>
    <Page wrap size="A4" orientation="landscape" style={styles.page}>
      <ReportTableHeader columns={columns} />
      <ReportTableItems columns={columns} table={table} />
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </Page>
  </Document>
);

Report.defaultProps = {
  title: 'Report',
  columns: [],
  image: '',
  table: {},
};

Report.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.array,
  image: PropTypes.string,
  table: PropTypes.object,
};

export default Report;
